import {CreationAttribute} from 'src/modules/event-create/typedefs';

export const getAttributeIds = (
    attributes: Array<CreationAttribute> | undefined,
): Array<number> => {
    if (attributes) {
        return attributes.map(attribute => Number(attribute.id));
    }

    return [];
};
